import { httpClient } from './httpClient';

let apiBaseUrl = process.env.REACT_APP_API_URL;


export const getScenarioByID = async uuidScenario => {
    return httpClient(`${apiBaseUrl}/scenarios/${uuidScenario}`);
};